import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getNivelEscolaridade, cadastrarNivelEscolaridade, alterarNivelEscolaridade, excluirNivelEscolaridade } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var NiveisEscolaridadeEditar = function () {
    var services = {
        getItem: getNivelEscolaridade,
        cadastrarItem: cadastrarNivelEscolaridade,
        alterarItem: alterarNivelEscolaridade,
        excluirItem: excluirNivelEscolaridade,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.NIVEIS_ESCOLARIDADE, paginaPermissao: FUNCIONALIDADES.NIVEIS_ESCOLARIDADE, rota: ROUTES.NIVEIS_ESCOLARIDADE, services: services });
};
export default NiveisEscolaridadeEditar;
